import { toast } from 'react-toastify';

export const handleErrorToast = (error, options = {}) => {
  const { suppressMessages = [], suppressStatusCodes = [] } = options;

  const message = error?.message;
  const status = error?.status || error?.statusCode;

  if (
    !message ||
    suppressMessages.includes(message) ||
    suppressStatusCodes.includes(status)
  ) {
    return;
  }

  toast(message);
};
